import { createFileRoute, Link } from "@tanstack/react-router";

// UI
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";

// Icons
import { ArrowLeft, Download, FileText, ExternalLink } from "lucide-react";

// Utils
import { cn } from "@/lib/utils";

export const Route = createFileRoute(
	"/_layout-private/chat/_layout/$id/document/",
)({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();

	return (
		<div className="h-full overflow-y-auto max-h-[calc(100vh-200px)]">
			<header className="relative flex items-center justify-center p-4 border-b">
				<Link to=".." className="absolute flex items-center text-sm left-4">
					<ArrowLeft className="mr-2 w-[16px] h-[16px]" />
					<span>ກັບຄືນ</span>
				</Link>

				<h2 className="font-bold text-[18px]">ເອກະສານທັງໝົດ</h2>
			</header>

			<div className="flex flex-col items-center text-sm gap-[24px] p-[28px]">
				<Avatar className="w-[120px] h-[120px]">
					<AvatarImage
						src={
							"https://s3-alpha-sig.figma.com/img/7ea8/e9d8/3d0dfc3355a8ebe07439efa12d01a48c?Expires=1733702400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=InaifSnN~Fr53AwsLnF5iqi8YUzuG2FXtvnbOB5qB9w5Yy9UrQAxIr4iZA~M~XW9mNwqQCFSvO1lk-gsav3BVHwOjGHCW4ekfAaj8q-zmCwKvU3hCILHApw3VRw~SQ58zN-sMyrmYtDqXyZTq7sceXX4cUlAgP8IIxXeUXovNEjGtI6AUZUia1aB6sNmRPwGgWGl7HI~Gsialeq6rQi~fnHVKqqQn06EIgWVVo~6ZXq24tYMlD1jzeXb4U4e5IuwfbLuYCLcS1F0XZsG66Df6tJOo7itSQuNb3CzuCp0G00DeTYm7OaBQ8LmQEmMjpulnGa5G32KdJ~~xvyVMeT9Rg__"
						}
					/>
					<AvatarFallback>{""}</AvatarFallback>
				</Avatar>

				<div className="flex flex-col items-center">
					<h2>ທະນາຄານການຄ້າ</h2>
					<p className="text-muted-foreground">020 1234 5678</p>
				</div>
			</div>

			<div className="w-full   px-[28px]">
				<Tabs defaultValue="accepted" className="w-full">
					<TabsList className="flex justify-between w-full p-0 bg-transparent border-b rounded-none place-items-center">
						<TabsTrigger
							className="data-[state=active]:active-tab-document h-full"
							value="accepted"
						>
							ເອກະສານທີ່ຕອບຮັບແລ້ວ
						</TabsTrigger>
						<TabsTrigger
							className="data-[state=active]:active-tab-document h-full"
							value="unaccepted"
						>
							ເອກະສານທີ່ຍັງບໍ່ໄດ້ຮັບ <span className="text-red-500">(2)</span>
						</TabsTrigger>
						<TabsTrigger
							className="data-[state=active]:active-tab-document h-full"
							value="pending"
						>
							ເອກະສານທີ່ລໍຖ້າການຕອບຮັບ
							<span className="text-red-500">(2)</span>
						</TabsTrigger>
					</TabsList>
					<TabsContent value="accepted">
						<div className="space-y-4">
							{acceptedFiles.map((file, index) => (
								<div
									key={index}
									className={cn(
										"flex",
										file.sender === "user" ? "justify-end" : "justify-start",
									)}
								>
									<div
										className={cn(
											"flex items-start gap-3 max-w-[80%] rounded-lg p-4",
											file.sender === "user"
												? "bg-primary text-primary-foreground"
												: "bg-muted",
										)}
									>
										<FileText className="w-6 h-6 shrink-0" />

										<div className="flex-1 min-w-0">
											<h3 className="font-medium truncate">{file.name}</h3>
											<p className="text-sm opacity-70">{file.time}</p>
										</div>

										<Button
											size="icon"
											variant={file.sender === "user" ? "secondary" : "ghost"}
											className="shrink-0"
											onClick={() => {
												// Handle download
												if (file.link) {
													window.open(file.link, "_blank");
												}
											}}
										>
											<Download className="w-4 h-4" />
										</Button>
									</div>
								</div>
							))}
						</div>
					</TabsContent>
					<TabsContent value="unaccepted">
						<div className="space-y-4">
							{unacceptedFiles.map((file, index) => (
								<div key={index} className="flex justify-start">
									<div className="flex flex-col max-w-[80%]">
										<div className="flex items-start gap-3 p-4 rounded-lg bg-muted">
											<FileText className="w-6 h-6 shrink-0" />

											<div className="flex-1 min-w-0">
												<h3 className="font-medium truncate">{file.name}</h3>
												<p className="text-sm text-muted-foreground">
													{file.time}
												</p>
											</div>

											<Button
												size="icon"

												className="shrink-0"
												onClick={() => {
													// Handle download
													if (file.link) {
														window.open(file.link, "_blank");
													}
												}}
											>
												<Download className="w-4 h-4" />
											</Button>
										</div>

										<Button
											className="w-full mt-2"
											variant="outline"
											onClick={() => {
												// Handle accept action
												console.log(`Accepting file: ${file.name}`);
											}}
										>
											ຍອມຮັບ
										</Button>
									</div>
								</div>
							))}
						</div>
					</TabsContent>
					<TabsContent value="pending">
						<div className="space-y-4">
							{pendingFiles.map((file, index) => (
								<div key={index} className="flex justify-end">
									<div className="flex flex-col max-w-[80%]">
										<div className="flex items-start gap-3 p-4 rounded-lg bg-primary text-primary-foreground">
											<FileText className="w-6 h-6 shrink-0" />

											<div className="flex-1 min-w-0">
												<h3 className="font-medium truncate">{file.name}</h3>
												<p className="text-sm opacity-70">{file.time}</p>
											</div>

											<Button
												size="icon"
												variant="secondary"
												className="shrink-0"
												onClick={() => {
													if (file.link) {
														window.open(file.link, "_blank");
													}
												}}
											>
												<Download className="w-4 h-4" />
											</Button>
										</div>

										<Button

											className="justify-start h-8 gap-2 mt-2 text-sm"
											onClick={() => {
												// Handle see more details action
												console.log(`View details for: ${file.name}`);
											}}
										>
											<ExternalLink className="w-4 h-4" />
											ເບິ່ງລາຍລະອຽດເພີ່ມເຕີມ
										</Button>
									</div>
								</div>
							))}
						</div>
					</TabsContent>
				</Tabs>
			</div>
		</div>
	);
}

const acceptedFiles = [
	{
		time: "2023-01-01",
		name: "Hi",
		link: "",
		sender: "other",
	},
	{
		time: "2023-01-01",
		name: "Hi2",
		link: "",
		sender: "other",
	},
	{
		time: "2023-01-01",
		name: "Hi3",
		link: "",
		sender: "user",
	},
	{
		time: "2023-01-01",
		name: "Hi",
		link: "",
		sender: "other",
	},
	{
		time: "2023-01-01",
		name: "Hi2",
		link: "",
		sender: "other",
	},
	{
		time: "2023-01-01",
		name: "Hi3",
		link: "",
		sender: "user",
	},
];

const unacceptedFiles = [
	{
		time: "2023-01-01",
		name: "Hi",
		link: "",
		// sender: "other",
	},
	{
		time: "2023-01-01",
		name: "Hi2",
		link: "",
		// sender: "other",
	},
	{
		time: "2023-01-01",
		name: "Hi3",
		link: "",
		// sender: "user",
	},
];

const pendingFiles = [
	{
		time: "2023-01-01",
		name: "Hi",
		link: "",
	},
	{
		time: "2023-01-01",
		name: "Hi2",
		link: "",
	},
	{
		time: "2023-01-01",
		name: "Hi3",
		link: "",
	},
];
